import React from 'react'

import { rtlRightLeft } from './rtlTransform'
import { useWrapperProps } from './hooks'

const Wrapper = (props: any) => {
  const { dir, style, Component, componentRef, rest } = useWrapperProps(props)
  const newProps = props.align ? { ...rest, align: rtlRightLeft(dir, props.align) } : rest
  return <Component {...newProps} dir={dir} style={style} ref={componentRef} />
}

export const HubInput = (props: any) => <Wrapper {...props} Component={'input'} />

export const HubTextarea = (props: any) => <Wrapper {...props} Component={'textarea'} />

export const HubLabel = (props: any) => <Wrapper {...props} Component={'label'} />

export const HubImage = (props: any) => <Wrapper {...props} Component={'img'} />

export const HubHeadline = (props: any) => <Wrapper {...props} Component={'h1'} />

export const HubHeadline2 = (props: any) => <Wrapper {...props} Component={'h2'} />

export const HubHeadline3 = (props: any) => <Wrapper {...props} Component={'h3'} />

export const HubParagraph = (props: any) => <Wrapper {...props} Component={'p'} />

export const HubPre = (props: any) => <Wrapper {...props} Component={'pre'} />

export const HubList = (props: any) => <Wrapper {...props} Component={'ul'} />

export const HubListItem = (props: any) => <Wrapper {...props} Component={'li'} />

export const HubLink = (props: any) => <Wrapper {...props} Component={'a'} />

export const HubText = (props: any) => <Wrapper {...props} Component={'div'} />
